import { render, staticRenderFns } from "./Portifolio.vue?vue&type=template&id=4ce531b7&"
import script from "./Portifolio.vue?vue&type=script&lang=js&"
export * from "./Portifolio.vue?vue&type=script&lang=js&"
import style0 from "./Portifolio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports